export default "__VITE_ASSET__Bkb$Ve1G__"